import { useState } from 'react'

import { CLICK_CODE, isEmptyArray } from '@local/utils'

import { UPCOMING_PAGE_SIZE } from '@web/pages/timeline/components/TimelineUpcoming'
import { useUpcomingBooking } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingBooking'
import { useUpcomingMore } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingMore'
import { useUpcomingOrder } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingOrder'
import { useUpcomingTotal } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingTotal'
import { useUpcomingTrainTicket } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingTrainTicket'
import UIUpcomingSection, { UpcomingSectionFilterType } from '@web/ui/pages/home/components/Sections/UIUpComingSection'

export enum UPCOMING_SECTION_TAB {
  TOTAL = 'TOTAL',
  BOOKING = 'BOOKING',
  ORDER = 'ORDER',
  TRAIN_TICKET = 'TRAIN_TICKET',
}

export const UpcomingSection = () => {
  const [upcomingSectionTab, setUpcomingSectionTab] = useState<UPCOMING_SECTION_TAB>(UPCOMING_SECTION_TAB.TOTAL)

  const { upcomingMore } = useUpcomingMore()

  const { upcomingTotalItems, upcomingTotalCount } = useUpcomingTotal({ limit: UPCOMING_PAGE_SIZE })

  const { upcomingBookingCount, upcomingBookingItems, upcomingBookingMore } = useUpcomingBooking({
    limit: UPCOMING_PAGE_SIZE,
  })

  const { upcomingOrderCount, upcomingOrderItems, upcomingOrderMore } = useUpcomingOrder({ limit: UPCOMING_PAGE_SIZE })

  const { upcomingTrainTicketCount, upcomingTrainTicketItems, upcomingTrainTicketMore } = useUpcomingTrainTicket({
    limit: UPCOMING_PAGE_SIZE,
  })

  const { displayUpcomingItems, hasMore } = (() => {
    if (upcomingSectionTab === UPCOMING_SECTION_TAB.TOTAL) {
      return {
        displayUpcomingItems: upcomingTotalItems.slice(0, UPCOMING_PAGE_SIZE),
        hasMore: upcomingTotalCount > UPCOMING_PAGE_SIZE,
      }
    }

    if (upcomingSectionTab === UPCOMING_SECTION_TAB.BOOKING) {
      return {
        displayUpcomingItems: upcomingBookingItems.slice(0, UPCOMING_PAGE_SIZE),
        hasMore: upcomingBookingMore,
      }
    }

    if (upcomingSectionTab === UPCOMING_SECTION_TAB.ORDER) {
      return {
        displayUpcomingItems: upcomingOrderItems.slice(0, UPCOMING_PAGE_SIZE),
        hasMore: upcomingOrderMore,
      }
    }

    if (upcomingSectionTab === UPCOMING_SECTION_TAB.TRAIN_TICKET) {
      return {
        displayUpcomingItems: upcomingTrainTicketItems.slice(0, UPCOMING_PAGE_SIZE),
        hasMore: upcomingTrainTicketMore,
      }
    }

    return {
      displayUpcomingItems: [],
      hasMore: false,
    }
  })()

  // 업커밍 카드 하나도 없으면 섹션 미노출
  if (isEmptyArray(upcomingTotalItems)) return null

  const handleClickMore = async ({ anchor }: { anchor?: boolean }) => {
    upcomingMore({ upcomingSectionTab, anchor })
  }

  const upcomingFilters: UpcomingSectionFilterType[] = [
    {
      name: '전체',
      count: upcomingTotalCount,
      onClick: () => {
        setUpcomingSectionTab(UPCOMING_SECTION_TAB.TOTAL)
      },
      isSelected: UPCOMING_SECTION_TAB.TOTAL == upcomingSectionTab,
      clickCodes: {
        filterClick: CLICK_CODE['myupcoming.allchip'],
        getMoreClick: CLICK_CODE['myupcoming.moreall'],
      },
    },
    {
      name: '주문',
      count: upcomingOrderCount,
      onClick: () => {
        setUpcomingSectionTab(UPCOMING_SECTION_TAB.ORDER)
      },
      isSelected: UPCOMING_SECTION_TAB.ORDER == upcomingSectionTab,
      clickCodes: {
        filterClick: CLICK_CODE['myupcoming.orderchip'],
        getMoreClick: CLICK_CODE['myupcoming.moreorder'],
      },
    },
    {
      name: '승차권',
      count: upcomingTrainTicketCount,
      onClick: () => {
        setUpcomingSectionTab(UPCOMING_SECTION_TAB.TRAIN_TICKET)
      },
      isSelected: UPCOMING_SECTION_TAB.TRAIN_TICKET == upcomingSectionTab,
      clickCodes: {
        filterClick: CLICK_CODE['myupcoming.trainticketchip'],
        getMoreClick: CLICK_CODE['myupcoming.moretrainticket'],
      },
    },
    {
      name: '예약',
      count: upcomingBookingCount,
      onClick: () => {
        setUpcomingSectionTab(UPCOMING_SECTION_TAB.BOOKING)
      },
      isSelected: UPCOMING_SECTION_TAB.BOOKING == upcomingSectionTab,
      clickCodes: {
        filterClick: CLICK_CODE['myupcoming.bookingchip'],
        getMoreClick: CLICK_CODE['myupcoming.morebooking'],
      },
    },
  ].filter(({ count }) => count > 0)

  return (
    <UIUpcomingSection
      title="다가오는 일정"
      upcomingItems={displayUpcomingItems}
      upcomingFilters={upcomingFilters}
      totalUpcomingItemCount={upcomingTotalCount}
      onClickMore={handleClickMore}
      hasMore={hasMore}
    />
  )
}
